import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'

const DataLoading = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding center-cont">
				{/* 일정 간격으로 롤링 */}
				<ul>
					{/* <li>
						<i className="icon icon_certificate_intro" />
						<h3 className="intro-tit mt_30">마이데이터 목록을 불러오고 있어요!</h3>
						<p className="intro-sub-tit mt_10">여기서 앱을 종료할 경우<br />
							마이데이터 연결이 중단되오니 주의해주세요.</p>
					</li> */}
					<li>
						<i className="icon icon_other_search" />
						<h3 className="intro-tit mt_30">조금만 더 기다려주세요!</h3>
						<p className="intro-sub-tit mt_10">여기서 앱을 종료할 경우<br />
							마이데이터 연결이 중단되오니 주의해주세요.
						</p>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default DataLoading
